import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { LanguageService } from '../services/language.service';

const API_URL_PREFIX = '/api/';

export const languageInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith(API_URL_PREFIX)) {
    return next(request);
  }

  const languageService = inject(LanguageService);

  return next(request.clone({ setHeaders: { 'Accept-Language': languageService.current() } }));
};
